"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "usePlaceholderHints", {
  enumerable: true,
  get: function () {
    return _usePlaceholderHints.usePlaceholderHints;
  }
});
Object.defineProperty(exports, "usePrevious", {
  enumerable: true,
  get: function () {
    return _usePrevious.usePrevious;
  }
});
var _usePlaceholderHints = require("./usePlaceholderHints");
var _usePrevious = require("./usePrevious");